export default __webpack_public_path__ + "static/avatar-a1ff7e86f9115be934bac811abcb7f27.png";